import { all, fork, put, call, takeEvery, take, cancel } from 'redux-saga/effects';
import { actions } from '../reducers/exhibition';
import { firestore, rsfDB } from '../lib/firebase';

// call은 동기, fork는 비동기 요청
function* syncExhibitionData(action) {
  const { id } = action;
  const task = yield fork(rsfDB.syncDocument, `Exhibition/${id}`, {
    successActionCreator: data => ({
      type: actions.SYNC_EXHIBITION_DATA_SUCCESS,
      data: data.data(),
    }),
    failureActionCreator: err => ({
      type: actions.SYNC_EXHIBITION_DATA_FAILURE,
      err: err.message,
    }),
  });
  yield take(actions.SYNC_EXHIBITION_DATA_DONE);
  yield cancel(task);
}
function* getExhibitionData(action) {
  const { id } = action;
  try {
    const snapshot = yield call(rsfDB.getDocument, `Exhibition/${id}`);
    yield put({
      type: actions.GET_EXHIBITION_DATA_SUCCESS,
      id: snapshot.id,
      data: snapshot.data(),
    });
  } catch (err) {
    yield put({
      type: actions.GET_EXHIBITION_DATA_FAILURE,
      error: err.message,
    });
  }
}
function* updateExhibitionData(action) {
  const { id, target, value }: { id: string; target: string; value: string } = action;
  try {
    yield call(rsfDB.updateDocument, `Exhibition/${id}`, target, value);
    yield put({
      type: actions.UPDATE_EXHIBITION_DATA_SUCCESS,
    });
  } catch (err) {
    yield put({
      type: actions.UPDATE_EXHIBITION_DATA_FAILURE,
      error: err.message,
    });
  }
}

function* getObjectData(action) {
  const { objectType, exhibitionId, id } = action;
  try {
    const snapshot = yield call(rsfDB.getDocument, `Exhibition/${exhibitionId}/${objectType}/${id}`);
    yield put({
      type: actions.GET_OBJECT_DATA_SUCCESS,
      data: snapshot.data(),
      id,
    });
  } catch (err) {
    yield put({
      type: actions.GET_OBJECT_DATA_FAILURE,
      error: err.message,
    });
  }
}
function* toggleLikeButton(action) {
  const { id, target, isLiked }: { id: string; target: string; isLiked: boolean } = action;
  try {
    yield call(
      rsfDB.updateDocument,
      `Exhibition/${id}/Paintings/${target}`,
      'like.count',
      isLiked ? firestore.FieldValue.increment(-1) : firestore.FieldValue.increment(1),
    );
    yield put({
      type: actions.TOGGLE_LIKE_BUTTON_SUCCESS,
    });
  } catch (err) {
    yield put({
      type: actions.TOGGLE_LIKE_BUTTON_FAILURE,
      error: err.message,
    });
  }
}

function* countView(action) {
  const { id }: { id: string } = action;

  try {
    yield call(rsfDB.updateDocument, `Exhibition/${id}`, 'views.todayView', firestore.FieldValue.increment(1));
    yield call(rsfDB.updateDocument, `Exhibition/${id}`, 'views.totalView', firestore.FieldValue.increment(1));
    yield put({
      type: actions.COUNT_VIEW_SUCCESS,
    });
  } catch (err) {
    yield put({
      type: actions.COUNT_VIEW_FAILURE,
      error: err.message,
    });
  }
}

function* plusCurrentView(action) {
  const { id, randomKey }: { id: string, randomKey: string } = action;

  try {
    yield call(rsfDB.updateDocument, `Exhibition/${id}`, `currentViews.${randomKey}`, firestore.FieldValue.increment(1));
    yield put({
      type: actions.PLUS_CURRENT_VIEW_SUCCESS,
    });
  } catch (err) {
    yield put({
      type: actions.PLUS_CURRENT_VIEW_FAILURE,
      error: err.message,
    });
  }
}

function* watchSyncExhibitionData() {
  yield takeEvery<string>(actions.SYNC_EXHIBITION_DATA_REQUEST, syncExhibitionData);
}
function* watchGetExhibitionData() {
  yield takeEvery<string>(actions.GET_EXHIBITION_DATA_REQUEST, getExhibitionData);
}

function* watchUpdateExhibitionData() {
  yield takeEvery<string>(actions.UPDATE_EXHIBITION_DATA_REQUEST, updateExhibitionData);
}
function* watchGetObjectData() {
  yield takeEvery<string>(actions.GET_OBJECT_DATA_REQUEST, getObjectData);
}
function* watchToggleLikeButton() {
  yield takeEvery<string>(actions.TOGGLE_LIKE_BUTTON_REQUEST, toggleLikeButton);
}
function* watchCountView() {
  yield takeEvery<string>(actions.COUNT_VIEW_REQUEST, countView);
}
function* watchPlusCurrentView() {
  yield takeEvery<string>(actions.PLUS_CURRENT_VIEW_REQUEST, plusCurrentView);
}
export default function* globalSaga() {
  yield all([
    fork(watchSyncExhibitionData),
    fork(watchGetExhibitionData),
    fork(watchUpdateExhibitionData),
    fork(watchGetObjectData),
    fork(watchToggleLikeButton),
    fork(watchCountView),
    fork(watchPlusCurrentView),
  ]);
}
